export default __webpack_public_path__ + "static/media/Account.79e59ad0.png";